import React from "react";
import ScreenLayout from "../../layout/ScreenLayout/ScreenLayout";
import { WidgetIntegrationForm } from "../../components/WidgetIntegrationForm/WidgetIntegrationForm";
import { useSelector } from "react-redux";

const IntegrationWidgetScreen = () => {
  const { activeWidget } = useSelector((state) => state?.widget);

  return (
    <ScreenLayout>
      <WidgetIntegrationForm data={activeWidget} />
    </ScreenLayout>
  );
};

export default IntegrationWidgetScreen;
